import { Component } from "solid-js";

interface InStoreBrandsIconProps {
  class?: string;
}

export const InStoreBrandsIcon: Component<InStoreBrandsIconProps> = (props) => {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class={props.class}
    >
      <path
        d="M5.62671 14.52V25.8533C5.62671 26.9579 6.52214 27.8533 7.62671 27.8533H24.0977C25.2023 27.8533 26.0977 26.9579 26.0977 25.8533V14.52"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.5681 27.852V21.9267C18.5681 20.2907 17.362 18.9641 15.8747 18.9641C14.3875 18.9641 13.1814 20.2907 13.1814 21.9267V27.852"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.73468 14.5187C3.47068 14.5027 1.99468 12.2613 2.97602 10.3293L5.26268 5.82668C5.78402 4.80001 6.88002 4.14801 8.08268 4.14801H23.9173C25.12 4.14801 26.216 4.80001 26.7373 5.82668L29.0253 10.3293C30.0067 12.2613 28.5307 14.5027 26.2667 14.5187C24.3773 14.5187 22.8453 13.228 22.8453 11.6347V11.5707C22.8453 13.1987 21.3133 14.5187 19.424 14.5187C17.5347 14.5187 16.0027 13.1987 16.0027 11.5707C16.0027 13.1987 14.4707 14.5187 12.5814 14.5187C10.692 14.5187 9.16002 13.1987 9.16002 11.5707V11.6347C9.15602 13.228 7.62402 14.5187 5.73468 14.5187Z"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
